import React from "react";
import { useTypewriter, Cursor } from "react-simple-typewriter";
import { BsCloudLightningFill, BsFacebook } from "react-icons/bs";
import { FaGithub, FaLinkedin, FaCode } from "react-icons/fa";
import { FiInstagram, FiMail, FiSend } from "react-icons/fi";
import CV from "./../../Paulo-Drefahl-Software-Engineer-Resume.pdf";
import { profilePhoto } from "../../assets/index";
import { profile, socialLinks } from "../../data/profile";

const socialIcons = {
  github: <FaGithub />,
  linkedin: <FaLinkedin />,
  facebook: <BsFacebook />,
  instagram: <FiInstagram />,
  leetcode: <FaCode />,
  mail: <FiMail />,
};

const Left = () => {
  const [text] = useTypewriter({
    words: profile.roles,
    loop: true,
    typeSpeed: 30,
    deleteSpeed: 20,
    delaySpeed: 2000,
  });

  const handleContactClick = () => {
    const { subject, body } = profile.contactPrefill;
    window.location.href = `mailto:${profile.email}?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
  };

  return (
    <div className="w-full lgl:w-5/12 h-full bg-bodyColor rounded-2xl shadow-testShwdow z-10">
      <div className="w-full h-3/5">
        <img
          className="w-full h-full object-cover rounded-2xl"
          src={profilePhoto}
          loading="priority"
          alt={profile.name}
        />
      </div>
      <div className="w-full h-2/5 flex flex-col justify-between border-t-0 rounded-bl-xl rounded-br-xl">
        <div className="flex flex-col items-center gap-2 py-10">
          <h1 className="text-textColor text-4xl font-semibold">
            {profile.name}
          </h1>
          <p className="text-base text-designColor tracking-wide">
            {text}
            <Cursor cursorBlinking="false" cursorStyle="|" />
          </p>
          <div className="flex justify-center gap-2 mt-2">
            {socialLinks.map(({ id, href }) => (
              <a
                key={id}
                href={href}
                target={href.startsWith("mailto:") ? undefined : "_blank"}
                rel="noopener noreferrer"
                className="hover:text-designColor duration-300 cursor-pointer text-xl"
              >
                {socialIcons[id]}
              </a>
            ))}
          </div>
        </div>
        <div className="flex h-14">
          <a
            href={CV}
            download="Paulo_Drefahl_CV.pdf"
            className="w-1/2 border-t-[1px] borderRight border-t-lineColor text-sm tracking-wide uppercase gap-2 hover:text-designColor duration-300"
            rel="noreferrer"
          >
            <button className="w-full h-full flex justify-center items-center gap-2">
              Download CV <BsCloudLightningFill />
            </button>
          </a>
          <button
            onClick={handleContactClick}
            className="w-1/2 border-t-[1px] border-t-lineColor text-sm tracking-wide uppercase flex justify-center items-center gap-2 hover:text-designColor duration-300"
          >
            Contact me <FiSend />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Left;
